import React from 'react';
import {Link, useNavigate} from 'react-router-dom';

const ProfileMenu = ({onLogout, setShowProfileMenu, unreadNotifications, onShowNotifications}) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    setShowProfileMenu(false);
    onLogout();
    navigate('/login');
 };

  return (
    <div className="profile-dropdown">
      <Link to="/profile" onClick={() => setShowProfileMenu(false)}>Tu Perfil</Link>
      <span
        className="profile-menu-notifications"
        onClick={() => {
          setShowProfileMenu(false);
          onShowNotifications();
       }}
      >
        Notificaciones
        {unreadNotifications && (
          <span className="notification-dot-inline"></span>
        )}
      </span>
      <Link to="/privacidad" onClick={() => setShowProfileMenu(false)}>Privacidad</Link>
      <button onClick={handleLogout}>Cerrar Sesión</button>
    </div>
  );
};

export default ProfileMenu;
// filepath: cookychat/src/Navegación/components/ProfileMenu.js